export const stripHtml = string => {
  return string.replace(/(<([^>]+)>)/gi, '');
};
